"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvailableBranches = exports.Branches = void 0;
var Branches;
(function (Branches) {
    Branches["Chemistry"] = "chemistry";
    Branches["Cosmetics"] = "cosmetics";
    Branches["Pharma"] = "pharma";
    Branches["Food"] = "food";
    Branches["IndustrialGoods"] = "industrialGoods";
})(Branches = exports.Branches || (exports.Branches = {}));
exports.AvailableBranches = [
    Branches.Chemistry,
    Branches.Cosmetics,
    Branches.Pharma,
    Branches.Food,
    Branches.IndustrialGoods
];
//# sourceMappingURL=branches.js.map